import { render } from "./SideBarMenuItem.html?vue&type=template&id=133885a9&scoped=true&ts=true&external"
import script from "./SideBarMenuItem.ts?vue&type=script&lang=ts&external"
export * from "./SideBarMenuItem.ts?vue&type=script&lang=ts&external"

import "./SideBarMenuItem.scss?vue&type=style&index=0&id=133885a9&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133885a9"]])

export default __exports__